import {useEffect, useState} from "react";

export function useAuthStatus(deps: any[] = []) {
  const [isAuth, setIsAuth] = useState(false);
  const [roleAuth, setRoleAuth] = useState<string | null>(null);
  const [userIdAuth, setUserIdAuth] = useState<string | null>(null);

  useEffect(() => {
    setIsAuth(!!localStorage.getItem("jwtRadar"));
    setRoleAuth(localStorage.getItem("roleRadar"));
    setUserIdAuth(localStorage.getItem("userIdRadar"));
  }, deps);

  return [
    isAuth,
    setIsAuth,
    roleAuth,
    setRoleAuth,
    userIdAuth,
    setUserIdAuth,
  ] as const;
}
